export const SET_QUOTE_IS_LOADING = 'SET_QUOTE_IS_LOADING'
export const SET_SELECTED_SHIPPING_ADDRESS = 'SET_SELECTED_SHIPPING_ADDRESS'
export const SET_SELECTED_SHIPPING_OPTION = 'SET_SELECTED_SHIPPING_OPTION'
export const SET_QUOTE_IS_FREIGHT_SHIPPING = 'SET_QUOTE_IS_FREIGHT_SHIPPING'
export const SET_QUOTE_SHIPPING_OPTIONS_IS_LOADING =
    'SET_QUOTE_SHIPPING_OPTIONS_IS_LOADING'
export const SET_QUOTE_IS_TAX_EXEMPT = 'SET_QUOTE_IS_TAX_EXEMPT'
export const SET_LINE_QUANTITY_ERROR = 'SET_LINE_QUANTITY_ERROR'
export const UPDATE_LINE_QUANTITY_ERROR_IDS = 'UPDATE_LINE_QUANTITY_ERROR_IDS'
export const SET_MAX_LEAD_TIME_DAYS = 'SET_MAX_LEAD_TIME_DAYS'
